import axios from "axios";
import axiosErrorHandler from "../ErrorHandler/axiosErrHandler";
import { refreshToken } from "../APIConfig/CtfConfig";
import jwtDecode from "jwt-decode";
import { startTransition } from "react";
import { toast } from "react-toastify";



const ParticipantAxios = axios.create({
  // baseURL: "https://devapi.bhumiitech.com/api"
  baseURL: process.env.REACT_APP_PARTICIPANT_API_PATH
});


// Add a request interceptor
ParticipantAxios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    // const currentPath = window.location?.pathname
    const token = localStorage.getItem("access_token");

    if (token) {
      // const token = localStorage.getItem("token");
      // if (token) {
      const decodedToken = jwtDecode(token);
      const isExpired = decodedToken.exp * 1000 < Date.now();
      console.log("Token expired:", isExpired, new Date(decodedToken.exp * 1000).toLocaleString());

      if (isExpired) {
        toast.error("Your session has expired. Redirecting to login...");

        setTimeout(() => {
          startTransition(() => {
            localStorage.removeItem("access_token");
            localStorage.removeItem("refresh_token");
            window.location.href = `/auth/loginParticipant`;
          });
        }, 3000);
      }
      // }
      // useTokenHandling()
    }

    // You can modify the request configuration here if needed
    return config;
  },
  function (error) {
    axiosErrorHandler(error);
    return Promise.reject(error);
  }
);

// Add a response interceptor
ParticipantAxios.interceptors.response.use(
  function (response) {
    // Do something with response data 
    // You can modify the response data here if needed

    const token = localStorage.getItem("access_token");

    if (token) {
      // const token = localStorage.getItem("token");
      // if (token) {
      const decodedToken = jwtDecode(token);
      const isExpired = decodedToken.exp * 1000 < Date.now();
      console.log("Token expired:", isExpired, new Date(decodedToken.exp * 1000).toLocaleString());

      if (isExpired) {
        toast.error("Your session has expired. Redirecting to login...");

        setTimeout(() => {
          startTransition(() => {
            localStorage.removeItem("access_token");
            localStorage.removeItem("refresh_token");
            window.location.href = `/auth/loginParticipant`;
          });
        }, 3000);
      }
      // }
      // useTokenHandling()
    }
    return response;
  },
  async function (error) {
    // Do something with response error
    const currentPath = window.location?.pathname;

    if (
      error?.response?.data?.exception ===
      "An error of type InvalidUser occurred: Expired Token."
    ) {
      // Wrap the data fetching in startTransition to make it low-priority
      startTransition(() => {
        refreshToken(currentPath);
      });
    }
    // if (error.response && error.response.status === 401) {
    //   // Token expired or not authorized
    //   // Redirect to the login page
    //   useNavigate("/login");
    // }
    // return Promise.reject(error);
    axiosErrorHandler(error);
    return Promise.reject(error);
  }
);

export default ParticipantAxios;